module.exports = __webpack_public_path__ + "static/logos-lawyers-mobile-abac4fb4f85b41b8b15cf9c6a1533cc3.png";